import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import AdminGuard from '@/components/AdminGuard';
import Sidebar from '@/components/Sidebar';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Users from '@/pages/Users';
import Monitoring from '@/pages/Monitoring';
import Database from '@/pages/Database';
import Audit from '@/pages/Audit';

/** 인증된 영역의 공통 레이아웃 (사이드바 + 본문) */
function AdminLayout() {
  return (
    <div className="admin-shell">
      <Sidebar />
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}

/** 관리자 웹 라우팅 루트 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 공개 라우트 */}
        <Route path="/login" element={<Login />} />

        {/* 인증 필요 영역 */}
        <Route
          element={
            <AdminGuard>
              <AdminLayout />
            </AdminGuard>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/monitoring" element={<Monitoring />} />
          <Route path="/database" element={<Database />} />
          <Route path="/audit" element={<Audit />} />
        </Route>

        {/* 알 수 없는 경로 → 대시보드 */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
